<script setup>
import { computed } from 'vue'
import { NOTIFICATION_TYPES } from '@/constants/connections'
import { useNotificationsStore } from '@/stores/NotificationsStore'
import { useRouter } from 'vue-router'

const props = defineProps({
  type: { type: String, required: true },
  id: { type: Number, required: true },
})

const notificationsStore = useNotificationsStore()

const router = useRouter()

// Sale notifications are mapped to `{}` and any type the backend adds later
// is not mapped at all; reading `.buttonLabel` off `undefined` would throw and
// take the whole notification panel down with it, so no link = no button.
const config = computed(() => NOTIFICATION_TYPES[props.type])

const handleClick = () => {
  notificationsStore.markAsRead(props.id)
  router.push(config.value.link)
}
</script>
<template>
  <button v-if="config?.link" class="text-xs text-tint-1 hover:underline cursor-pointer self-start" @click="handleClick">
    {{ config.buttonLabel }}
  </button>
</template>